<template>
  <el-container>
    <el-header class="header" height="140px"></el-header>
    <el-main :style="'height:'+mainHeight+'px'" class="main">
      <div class="login-top">
        <div class="login-topBg">
          <div class="login-topBg1">
            <div class="login-topStyle" >
              <div class="login-topStyle3" id="loginStyle" style="margin-top: 35px;">
                <h3>智慧农业控制平台</h3>
                <div class="ui-form-item loginUsername" >
                  <el-input type="username" placeholder="用户名/手机号/密码" v-model="userName"></el-input>
                </div>
                <div class="ui-form-item loginPassword" >
                  <el-input type="password" placeholder="请输入密码" v-model="password"></el-input>
                </div>
                <div class="ui-form-item loginCode">
                  <el-input class="vali-code" type="code" placeholder="请输入验证码" v-model="code"></el-input>
                  <img id="vailCodeImg" v-on:click="changeCode" :src="'data:image/png;base64,' + valiCodeBase64" style="top:14px;position:relative;"/>
                </div>
                <div class="login_reme"><a class="btnStyle btn-register" href="javascript:void(0);" v-on:click="login"> 立&nbsp;即&nbsp;登&nbsp;录</a> </div>
              </div>
            </div>
          </div>
        </div>
        <div class="loginCen">
          <div class="login-center">
            <div class="loginCenter-moudle">
              <div class="loginCenter-moudleLeft" style="margin-right: 60px;"> &nbsp;</div>
              <div class="loginCenter-moudleRight" style="  width: 1067px;">
                <a class="loginCenter-mStyle loginCenter-moudle1" id="moudleRemove" style=" display:block;width: 340px;">
                  <span class="moudle-img"><img src="../../assets/login/login_bg_01.png"></span>
                  <span class="moudle-text">
                    <span class="moudle-text1">实时监控</span>
                    <span class="moudle-text2">可实时查看各设备运行情况</span>
                  </span>
                </a>
                <a class="loginCenter-mStyle loginCenter-moudle2" style=" display:block; width: 357px;" id="moudleRemove2" >
                  <span class="moudle-img"><img src="../../assets/login/login_bg_02.png"></span>
                  <span class="moudle-text">
                    <span class="moudle-text1">自动报警</span>
                    <span class="moudle-text2">设备运维突发情况自动报警</span>
                  </span>
                </a>
                <a class="loginCenter-mStyle loginCenter-moudle3" style=" display:block;" id="moudleRemove3" >
                  <span class="moudle-img"><img src="../../assets/login/login_bg_03.png"></span>
                  <span class="moudle-text">
                    <span class="moudle-text"> <span class="moudle-text1">分析统计</span>
                    <span class="moudle-text2">根据设施数据形成数据仓·分析</span></span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer class="footer" height="60px"><span class="copyright">Copyright © 嘉兴创耕农业技术服务有限公司</span></el-footer>
  </el-container>
</template>

<script>
import requestService from '../../util/request'
import md5 from 'js-md5'
export default {
  data () {
    return {
      msg: '',
      mainHeight: 460,
      valiCodeBase64: '',
      valiUuid: '',
      userName: '',
      password: '',
      code: ''
    }
  },
  created () {
    this.mainHeight = window.innerHeight - 140 - 60
    console.log(this.$global.apiUrl)
    this.changeCode()
  },
  methods: {
    changeCode: function () {
      let that = this
      requestService.get('/valiCode', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        console.log(res)
        that.valiCodeBase64 = res.data.valiCodeBase64
        that.valiUuid = res.data.valiUuid
      })
    },
    login: function (e) {
      let that = this
      requestService.post('/login', {
        userName: that.userName,
        password: md5(that.password),
        code: that.code,
        valiUuid: that.valiUuid
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        localStorage.setItem('token', res.data.token)
        this.$router.replace('/dataV/index')
      })
    }
  }
}
</script>

<style scoped>
@import '../../assets/login/login.css';
.header{
  background-color: #F5F5F5;
}
.main{
  background-color: #FFFFFF;
}
.footer{
  background-color: #e1e1e1;
  text-align: center;
}
.footer .copyright{
  line-height: 60px;
  font-size: 12px;
  color: #606060;
}
</style>



// WEBPACK FOOTER //
// src/components/login/Index.vue